import React from "react";
import Hero from "../components/Hero/Hero";
import Converter from "../components/Converter/Converter";

const Home = () => {
  return (
    <div>
      <Hero />
      <Converter />
    </div>
  );
};

export default Home;
